import React from 'react';

function getInitiation(product){
    if (product.initiation_fee){
        if (product.is_on_sale && product.initiation_fee_was){
            return (
                    <div>
                        <div className="initiation">
                            Initiation:
                            &nbsp;
                            <span className="strikethrough" >{product.initiation_fee_was}</span>
                            &nbsp;
                            <span className="new-initiation">
                                {product.initiation_fee}
                            </span>
                        </div>
                    </div>
                )
        }else{
            return (
                <div className="initiation">
                    Initiation:&nbsp;&nbsp;
                    {product.initiation_fee}
                </div>
            )
        }
    }
}

function getMonthlyDues(product){
    if (product.is_on_sale && product.monthly_dues_was){
        return(
            <div>
                <div className="price">
                    Due Today:
                    <span className="strikethrough" >{product.amount_dues_was}
                        <span> /mo </span>
                    </span>
                </div>
                <div className="new-price">
                    {product.monthly_dues}
                    <span> /mo </span>
                </div>
            </div>
        )
    }else{
        // would be ideal to break cents (.00) out from dollars here
        return(
            <div className="price">
                { splitDollarsAndCents( product.monthly_dues ) }
                <span className="monthLabel"> /mo </span>
            </div>
        )
    }
}

function getAnnualFee(product){
    if (product.annual_fee){
        return (
            <div className="annual">
            Annual Fee:&nbsp;&nbsp;
            {product.annual_fee}
            </div>
        )
    }
}

function getAmountDueToday(product){
    if (product.is_on_sale && product.amount_due_today_was){
        return(
            <div>
                <div className="dueToday">
                    Due Today:
                    &nbsp;
                    <span className="strikethrough" >{product.amount_due_today_was} </span>
                </div>
                <div className="new-dueToday">
                    Due Today:&nbsp;&nbsp;
                    {product.amount_due_today}
                </div>
            </div>
        )
    }else{
        return(
            <div className="dueToday">
                Due Today:&nbsp;&nbsp;
                {product.amount_due_today}
            </div>
        )
    }
}
function getSaleDuration(product){
    if (product.is_on_sale && product.offer_valid_through){
        return(
            <div className="validThroughText">{product.offer_valid_through}</div>
        )
    }
}

function splitDollarsAndCents(price){
    var dollars = ( price.indexOf('$') > -1 ? price.split('$')[1] : price ).split('.')[0],
        cents = price.split('.')[1];

    return (
        <span className="dollarAmount">
            <span className="sign">$</span>
            <span className="dollars">{ dollars }</span>
            <span className="dot">.</span>
            <span className="cents">{ cents }</span>
        </span>
    );
}

function getPaymentAndTerm(product){
    //if no term, month, but do all the same monthly sale checks
    if (product.is_monthly) {
        if (product.is_on_sale && product.monthly_dues_was){
            return(
                <div>
                    <div className="price">
                        <span className="strikethrough" >{product.monthly_dues_was}
                            <span> /mo </span>
                        </span>
                    </div>
                    <div className="new-price">
                        {product.monthly_dues}
                        <span> /mo </span>
                    </div>
                </div>
            )
        }else{
            return(
                <div className="price">
                    { splitDollarsAndCents( product.monthly_dues ) }
                    <span className="monthLabel"> /mo </span>
                </div>
            )
        }
    }else{
        if (product.is_on_sale && product.amount_due_today_was){
            return(
                <div>
                    <div className="price">
                        <span className="strikethrough" >{product.amount_dues_was}
                            <span>  {product.amount_due_today_was}
                                <span> / {product.prepaid_term}  </span>
                            </span>
                       </span>
                    </div>
                    <div className="new-price">
                        { splitDollarsAndCents( product.amount_due_today ) }
                        <span> / {product.prepaid_term}  </span>
                    </div>
                </div>
            )
        }else{
            return(
                <div className="price">
                    { splitDollarsAndCents( product.amount_due_today ) }
                    <span className="monthLabel"> / {product.prepaid_term} </span>
                </div>
            )
        }
    }
}
function isCommitVerbage(product){
    if (product.is_commit){
        return (
            <span>{product.commitment_months} month commitment is required.</span>
        )
    }else{
        return (
            <span>No commitment.</span>
        )
    }
}

function bestValue( product ) {
    if ( product.subline === 'Reduced Dues' ){
        return (
            <span className="tag tagYellow">Best Value</span>
        );
    } else {
        return '';
    }
}

export {  getInitiation , getMonthlyDues , getAnnualFee, getAmountDueToday, getSaleDuration,  getPaymentAndTerm, isCommitVerbage, bestValue }



// WEBPACK FOOTER //
// ./src/components/DGR/MembershipOptions/ProductInfoItems.js